import React, { SyntheticEvent, useState } from 'react';

import { Helmet } from 'react-helmet';

import { Box, Container, Tab, Tabs } from '@mui/material';

import PageHeader from '~/components/Common/Elements/PageHeader';

import BusinessListPanel from '../components/BusinessListPanel';

type BusinessStatus = 'active' | 'deactivated';

const TAB_VALUES: Array<BusinessStatus> = ['active', 'deactivated'];

export default function MainPage() {
  const title = 'Businesses';
  const [activeTab, setActiveTab] = useState<BusinessStatus>('active');

  function handleTabChange(_event: SyntheticEvent, newValue: number) {
    setActiveTab(TAB_VALUES[newValue]);
  }

  return (
    <Container maxWidth="xl">
      <Helmet>
        <title>{title}</title>
      </Helmet>
      <PageHeader title={title} />
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs value={TAB_VALUES.indexOf(activeTab)} onChange={handleTabChange}>
          <Tab label="Active" />
          <Tab label="Deactivated" />
        </Tabs>
      </Box>
      <Box mt={2}>
        <BusinessListPanel key={activeTab} status={activeTab} />
      </Box>
    </Container>
  );
}
